import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "@/store";
import i18n from "@/lang";
import UlearningUI from "ulearning-ui";
import { ORG_SITE, UMOOC_WEB_HOST } from "@/config";
import { getTextbookRelation } from "@/api/courseApi";

import "ulearning-ui/lib/styles/index.css";

import "element-ui/lib/theme-chalk/index.css";
Vue.use(UlearningUI);

import UlPage from "./components/page";
Vue.use(UlPage);

import { Tooltip, Tree, Collapse, CollapseItem } from "element-ui";
Vue.use(Tooltip);
Vue.use(Tree);
Vue.use(Collapse);
Vue.use(CollapseItem);

import "normalize.css";
import "@/assets/fonts/iconfont.css";
import "@/assets/fonts/iconfont.js";
import "./styles/common.scss";

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

const initVue = async () => {
  const hash = window.location.hash; // #/course/home/9771
  const courseId = hash.split("/").pop(); // 9771
  if (hash.includes("/course/home/")) {
    try {
      const result = await getTextbookRelation({ textbookId: courseId });
      if (result.qualitytype == 2) {
        location.replace(`${UMOOC_WEB_HOST}/ai/#/course/${courseId}`);
      } else {
        newVue();
      }
    } catch (error) {
      newVue();
    }
  } else {
    newVue();
  }
};

const newVue = () => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
    created() {
      if (ORG_SITE != "umooc") {
        store.dispatch("org/setOrg");
      }
    },
  }).$mount("#app");
};

store
  .dispatch("user/setUser")
  .then(() => {
    initVue();
  })
  .catch((err) => {
    console.log(err);
    initVue();
  });
